// Kept free of imports: utils needing a storage key must not pull the #imports barrel (cycles)

export const StorageKeys = {
  /** Sidebar collapsed state */
  UISidebarCollapsed: "UISidebarCollapsed",
  /** User language preference (fr-FR, en-US) */
  LangPreference: "LangPreference",
  /** KPI aggregation mode in company page (company, site, asset) */
  KPICompanyAggModeCompany: "KPICompanyAggModeCompany",
  /** KPI aggregation mode in sidebar navigation (company, site, asset) */
  KPICompanyAggModeSideBar: "KPICompanyAggModeSideBar",
  /** Global search query persistence */
  GlobalSearch: "globalSearch",
  /** Global search selected type filters */
  GlobalSearchSelectedTypes: "GlobalSearchSelectedTypes",
  /** Default chart tag for supervision page (gs, dh) */
  UISupervisionDefaultChart: "UISupervisionDefaultChart",
  /** Filter to show only internal/external companies */
  GSCompanyIsExternal: "GSCompanyIsExternal",
  /** Toggle to compare metrics vs budget */
  GSCompanyIsVsBudget: "GSCompanyIsVsBudget",
  /** Budget percentile used for GS budget columns and gauges (shared across company, site and contract pages) */
  GSBudgetPercentile: "GSBudgetPercentile",
  /** Finance chart stacking option, stored per aggregation level (contract, site, assetowner, ...) */
  GSFinanceStackBy: "GSFinanceStackBy",
  /** Toggle to show consumption in site active power chart */
  SiteActivePowerShowConsumption: "SiteActivePowerShowConsumption",
  /** ISO date of the last time the user opened the release notes page */
  ReleasesLastVisit: "ReleasesLastVisit",
  /** Site events analysis heatmap mode (unavailable_time, to_review) last picked */
  TimelineHeatmapMode: "TimelineHeatmapMode",
  /** Energy-efficiency supply figures shown in MWh or kWh */
  SupplyEnergyUnit: "SupplyEnergyUnit",
  /** Format of the dates displayed to the user (iso, locale), picked in the settings page */
  DateFormat: "DateFormat",
} as const
